import { headConfig } from '@/_cactus_core/config/head';

interface Seo {
  title: string;
  description?: string;
}

export default ({ title, description }: Seo) => {
  const { appName } = useRuntimeConfig().public;
  const layout = useLayoutStore();

  const the_title = computed(() => {
    if (title) {
      if (title.includes(appName)) {
        return title;
      } else {
        return `${title} | ${appName}`;
      }
    }

    return headConfig().seoDefaultPageTitle;
  });

  const the_description = computed(() => {
    if (description) {
      if (description.includes(appName)) {
        return description;
      } else {
        return `${description} | ${appName}`;
      }
    }

    return headConfig().seoDefaultPageDescription;
  });

  layout.setFooterDescription(the_description.value);

  useSeoMeta({
    title: () => `${the_title.value}`,
    ogTitle: () => `${the_title.value}`,
    description: () => `${the_description.value}`,
    ogDescription: () => `${the_description.value}`,
  });
};
